import { getVisaBookingList} from '@/src/api/services/visaService'
import { RootState } from '@/src/store'
import { VisaBookingListData } from '@/src/types/visa/visaBookingList'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: VisaBookingListData = {
    isLoading: true,
    visaBookingList: []
}

export const fetchVisaBookingList = createAsyncThunk(
    'visaBookingList/fetchVisaBookingList',
    async () => {
        const response = await getVisaBookingList()
        return response
    }
)

const visaBookingListSlice = createSlice({
    name: 'visaBookingList',
    initialState,
    reducers: {
        setVisaBookingList: (state, action) => {
            state.visaBookingList = action.payload
        },

        setLoading: (state, action: PayloadAction<boolean>) => {
            state.visaBookingList = state.visaBookingList.map((booking) => ({
                ...booking,
                isLoading: action.payload
            }))
        }
    },
    extraReducers(builder) {
        builder.addCase(fetchVisaBookingList.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(
            fetchVisaBookingList.fulfilled,
            (state, action: { payload: any }) => {
                state.isLoading = false
                state.visaBookingList = action.payload
                console.log(JSON.stringify(action.payload))
            }
        )
        builder.addCase(fetchVisaBookingList.rejected, (state) => {
            state.isLoading = false
        })
    }
})

export const { setVisaBookingList, setLoading } = visaBookingListSlice.actions
export const getVisaBookingListState = (state: RootState) =>
    state.visaBookingList
export default visaBookingListSlice.reducer
